<template>
  <div class="menu-wrapper">
  	<!--如果hasChild为true，则代表有子菜单;childNodes.length等于0则表示没有所有子菜单的权限，则此时不进行渲染-->
  	<el-submenu  v-if="item.hasChild&&item.childNodes.length>0" :index="item.name">
        <template slot="title">
        	<i class="menusIcon iconfont" v-if="item.icon" :class="item.icon"></i><span v-if="item.title" slot="title">{{item.title}}</span>
        </template>
        <template v-for="child in item.childNodes">
        	 <!--递归渲染下一级菜单-->
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.hasChild&&child.childNodes.length>0" :item="child" :key="child.name"></sidebar-item>
          <div v-else-if="!child.hasChild" :key="child.name"  @click="handelTo(child.name)">
            <el-menu-item :index="child.name">
            	<i class="menusIcon iconfont" v-if="child.icon" :class="child.icon"></i><span v-if="child.title" slot="title">{{child.title}}</span>
            </el-menu-item>
          </div>
        </template>
      </el-submenu>
      <!--如果hasChild为false，则代表无子菜单，为一级菜单项-->
      <div v-else-if="!item.hasChild" @click="handelTo(item.name)" :key="item.name">
        <el-menu-item :index="item.name" :class="{'submenu-title-noDropdown':!isNest}">         
         	<i class="menusIcon iconfont" v-if="item.icon" :class="item.icon"></i><span v-if="item.title" slot="title">{{item.title}}</span>
        </el-menu-item>
      </div>      
  </div>
</template>

<script>
import FixiOSBug from './FixiOSBug'

/* 后台获取的菜单json权限数组各级name属性即与项目router各级路由配置name属性相对应，
 * 遍历生成<router-link>时，:to通过name绑定到相应的路由，实现接口数据与本地路由组件的结合
 */

export default {
  name: 'SidebarItem',
  mixins: [FixiOSBug],
  props: {
    // route配置json
    item: {
      // type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  mounted() {
  },
  methods: {
  	handelTo(actionName) {
  		this.$store.dispatch('delAllCachedView')
  		this.$router.push({
  			name: actionName
  		})
  	},
    hasChild(children) {
    	if (children !== undefined) {
    		return true
    	} else {
    		return false
    	}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue